module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav border"
  }, [(_vm.ssoFlag === 0) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'finder',
        params: {
          ishome: true
        }
      }
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search1",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "id": "search1",
      "placeholder": "输入基因名称...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])], 1) : _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "item-link item-content",
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMymessage()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem",
      "height": "2rem"
    },
    attrs: {
      "src": "/static/img/kefu.png"
    }
  }), _vm._v(" "), (_vm.curMessageSession.unreadMessagesAmount > 0) ? _c('span', {
    staticClass: "unreadmessage"
  }, [_vm._v("\r\n           " + _vm._s(_vm.curMessageSession.unreadMessagesAmount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2.5rem",
      "background-color": "#FFFFFF"
    }
  }, [(_vm.promotions) ? _c('div', {
    staticClass: "swiper-container swiper-container-horizontal",
    staticStyle: {
      "margin-left": "0.2rem",
      "margin-right": "0.2rem"
    },
    attrs: {
      "id": "sw1",
      "data-space-between": "10"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.promotions), function(attr) {
    return (attr.imageUrl) ? _c('div', {
      staticClass: "swiper-slide"
    }, [(_vm.openLink(attr)) ? _c('a', {
      attrs: {
        "href": _vm.getOuterLink(attr)
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + attr.imageUrl,
        "id": attr.promotionGuid
      }
    })]) : _c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + attr.imageUrl,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.todiscount(attr)
        }
      }
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }, _vm._l((_vm.promotions), function(index) {
    return _c('span', [(index === 0) ? _c('span', {
      staticClass: "swiper-pagination-bullet swiper-pagination-bullet-active "
    }) : _vm._l((_vm.promotions), function(index) {
      return _c('span', {
        staticClass: "swiper-pagination-bullet"
      })
    })], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticStyle: {
      "color": "#8e8e93",
      "margin-bottom": "0.5rem",
      "font-size": "0.8rem",
      "margin-left": "0.5rem",
      "margin-right": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.todiscount(_vm.promotionGuid, _vm.description)
      }
    }
  }, [_vm._v("查看全部")]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.channels) ? _c('div', {
    staticClass: "swiper-container  ",
    staticStyle: {
      "width": "100%",
      "height": "24%",
      "padding-bottom": "0px"
    },
    attrs: {
      "id": "sw"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [(_vm.channels.length > 1) ? _c('tr', _vm._l((_vm.channels), function(channel) {
    return _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "0.2rem",
        "margin-left": "0.2rem"
      },
      on: {
        "click": function($event) {
          return _vm.gotochannel(channel)
        }
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + channel.imageUrl,
        "alt": ""
      }
    })])])
  }), 0) : _c('tr', [_vm._l((_vm.channels), function(channel) {
    return _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "0.2rem",
        "margin-left": "0.2rem"
      },
      on: {
        "click": function($event) {
          return _vm.gotochannel(channel)
        }
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + channel.imageUrl,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8e8e93",
      "margin-bottom": "0.5rem",
      "font-size": "0.8rem",
      "margin-left": "0.5rem",
      "margin-right": "0.5rem"
    }
  }, [_c('span', [_vm._v("猜你喜欢")]), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.topromotion('', '猜你喜欢')
      }
    }
  }, [_vm._v("查看全部")]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-right"
  })])]), _vm._v(" "), (_vm.recommendsList && _vm.recommendsList.length > 0) ? _c('div', [_c('newMerchandiseListB', {
    attrs: {
      "merchList": _vm.recommendsList
    }
  })], 1) : _c('div', [_c('newMerchandiseListB', {
    attrs: {
      "merchList": _vm.recommends
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "查询基因/产品名称……",
      "readonly": "",
      "unselectable": "on"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1e6d314","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1727
// module chunks = 8